// oxlint-disable-next-line import/no-duplicates
import type { EmojiNodeDataProvider } from '@atlaskit/editor-plugin-emoji';
import type { EmojiPluginOptions } from '@atlaskit/editor-plugin-emoji';
import type { EmojiProvider } from '@atlaskit/emoji';

interface Props {
	options: Pick<EmojiPluginOptions, 'contentId'> | undefined;
	providers: {
		emojiNodeDataProvider: EmojiNodeDataProvider | undefined;
		emojiProvider: Promise<EmojiProvider> | undefined;
	};
}

export function emojiPluginOptions({ options, providers }: Props): EmojiPluginOptions {
	return {
		contentId: options?.contentId,
		emojiProvider: providers.emojiProvider,
		emojiNodeDataProvider: providers.emojiNodeDataProvider,
	};
}
